import React, { useState, useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Row, Col, Button, Table, Modal } from 'react-bootstrap';
import { BiPrinter, BiCloudDownload } from "react-icons/bi";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { QRCodeCanvas } from "qrcode.react";

function generatePDF(format = 'receipt') {
  const invoiceElement = document.querySelector("#invoiceCapture");

  html2canvas(invoiceElement, {
    scale: 2,
    scrollY: -window.scrollY,
    useCORS: true
  }).then((canvas) => {
    const imgData = canvas.toDataURL('image/png');
    let pdf;

    if (format === 'receipt') {
      // Dynamic height calculation based on content
      const receiptWidth = 56; // 56mm width
      const contentHeight = (canvas.height * receiptWidth) / canvas.width;
      const minHeight = 100; // Minimum height to avoid extra space
      const finalHeight = Math.max(contentHeight, minHeight);

      pdf = new jsPDF({
        orientation: 'p',
        unit: 'mm',
        format: [receiptWidth, finalHeight] // Adjust height dynamically
      });

      pdf.addImage(imgData, 'PNG', 0, 0, receiptWidth, finalHeight);
      pdf.save("receipt.pdf");

    } else {
      // Standard A4 invoice
      const imgWidth = 210; // A4 width in mm
      const pageHeight = 297; // A4 height in mm
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;
      let position = 0;

      pdf = new jsPDF('p', 'mm', 'a4');
      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      pdf.save("invoice.pdf");
    }
  });
}






function GooglePayScanner({ total }) {
  const paymentUrl = `upi://pay?pa=jyotsanabenpatel1710@okhdfcbank&pn=Prit Patel&am=${total}&cu=INR`;

  return (
    <div className="text-center mt-2" id="gpayScanner">
      <h6 className="fw-bold mb-2">Scan to Pay with Google Pay</h6>
      <QRCodeCanvas id="qrCodeCanvas" value={paymentUrl} size={150} />
      <p className="mt-1" id="amountValue">{total}</p>
      <p className="text-muted">UPI ID: jyotsanabenpatel1710@okhdfcbank</p>
    </div>
  );
}

class InvoiceModal extends React.Component {
  render() {
    const {
      showModal, closeModal, info, items, currency, subTotal,
      taxAmount, discountAmount, deliveryAmount, total
    } = this.props;

    return (
      <div>
        <Modal show={showModal} onHide={closeModal} size="lg" centered>
          <div id="invoiceCapture" className="p-4">
            <div className="d-flex justify-content-between align-items-start border-bottom pb-3">
              <div>
                <h5 className="fw-bold">Invoice: {info.invoiceNumber || 'XXXXXX'}</h5>
                <p className="fw-bold">Date of Issue: {info.issueDate || new Date().toLocaleDateString()}</p>
              </div>
              <h4 className="fw-bold text-center flex-grow-1">{info.billFrom || 'Shop Name'}</h4>
              <div className="text-end">
                <h6 className="fw-bold text-danger">Amount Due</h6>
                <h5 className="fw-bold">{currency} {total}</h5>
              </div>
            </div>

            <div className="text-start mt-3">
              <p><span className="fw-bold">Due Date:</span> {info.dueDate || 'DD/MM/YYYY'}</p>
              <p><span className="fw-bold">Bill To:</span> {info.billTo || 'Customer Name'}</p>
            </div>

            <Table bordered size="sm" className="mb-3">
              <thead>
                <tr>
                  <th>QTY</th>
                  <th>DESCRIPTION</th>
                  <th>PRICE</th>
                  <th>AMOUNT</th>
                </tr>
              </thead>
              <tbody>
                {items.map((item, i) => (
                  <tr key={i}>
                    <td>{item.quantity}</td>
                    <td>{item.name}</td>
                    <td>{currency} {Number(item.price).toFixed(2)}</td>
                    <td>{currency} {(Number(item.price) * Number(item.quantity)).toFixed(2)}</td>
                  </tr>
                ))}
              </tbody>
            </Table>

            <Table size="sm" className="mb-3">
              <tbody>
                <tr>
                  <td className="fw-bold">SUBTOTAL</td>
                  <td className="text-end">{currency} {subTotal}</td>
                </tr>
                {taxAmount !== 0 && (
                  <tr>
                    <td className="fw-bold">TAX</td>
                    <td className="text-end">{currency} {taxAmount}</td>
                  </tr>
                )}
                {discountAmount > 0 && (
                  <tr>
                    <td className="fw-bold">DISCOUNT</td>
                    <td className="text-end">{currency} {discountAmount}</td>
                  </tr>
                )}
                {deliveryAmount !== 0 && (
                  <tr>
                    <td className="fw-bold">DELIVERY</td>
                    <td className="text-end">{currency} {deliveryAmount}</td>
                  </tr>
                )}
                <tr>
                  <td className="fw-bold">TOTAL</td>
                  <td className="text-end">{currency} {total}</td>
                </tr>
              </tbody>
            </Table>

            <GooglePayScanner total={total} />
          </div>
          <div className="pb-3 px-3">
            <Row>
              <Col>
                <Button variant="primary" className="w-100" onClick={() => generatePDF('receipt')}>
                  <BiPrinter className="me-2" />Print Receipt
                </Button>
              </Col>
              <Col>
                <Button variant="outline-primary" className="w-100" onClick={() => generatePDF('a4')}> 
                  <BiCloudDownload className="me-2" />Download Copy
                </Button>
              </Col>
            </Row>
          </div>
        </Modal>
      </div>
    );
  }
}

export default InvoiceModal;
